/**
 * @generated SignedSource<<3f360a3d2ee2dd314d79800f5770ea54>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useWorkspaceTodoEditAddImageMutation$variables = {
  todoId: string;
};
export type useWorkspaceTodoEditAddImageMutation$data = {
  readonly todoWorkspace: {
    readonly uploadImage: {
      readonly image: {
        readonly id: string;
      };
      readonly imageUploadUrl: string;
      readonly todoWorkspace: {
        readonly descriptionImages: ReadonlyArray<{
          readonly id: string;
        }>;
        readonly id: string;
        readonly " $fragmentSpreads": FragmentRefs<"WorkspaceTodoEditMainEditedInfo_Todo">;
      };
    };
  };
};
export type useWorkspaceTodoEditAddImageMutation = {
  response: useWorkspaceTodoEditAddImageMutation$data;
  variables: useWorkspaceTodoEditAddImageMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "todoId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "todoId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = [
  (v2/*: any*/)
],
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "Image",
  "kind": "LinkedField",
  "name": "image",
  "plural": false,
  "selections": (v3/*: any*/),
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "imageUploadUrl",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "Image",
  "kind": "LinkedField",
  "name": "descriptionImages",
  "plural": true,
  "selections": (v3/*: any*/),
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useWorkspaceTodoEditAddImageMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "TodoWorkspaceMutation",
        "kind": "LinkedField",
        "name": "todoWorkspace",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UpdateTodoWorkspaceUploadImagePayload",
            "kind": "LinkedField",
            "name": "uploadImage",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "TodoWorkspace",
                "kind": "LinkedField",
                "name": "todoWorkspace",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "WorkspaceTodoEditMainEditedInfo_Todo"
                  },
                  (v6/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useWorkspaceTodoEditAddImageMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "TodoWorkspaceMutation",
        "kind": "LinkedField",
        "name": "todoWorkspace",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UpdateTodoWorkspaceUploadImagePayload",
            "kind": "LinkedField",
            "name": "uploadImage",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "TodoWorkspace",
                "kind": "LinkedField",
                "name": "todoWorkspace",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "updatedBy",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "name",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UnzonedDate",
                    "kind": "LinkedField",
                    "name": "updatedAtDate",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isoString",
                            "storageKey": null
                          }
                        ],
                        "type": "Date",
                        "abstractKey": "__isDate"
                      }
                    ],
                    "storageKey": null
                  },
                  (v6/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "79cb1ce0b590102291e2366faf72f66f",
    "id": null,
    "metadata": {},
    "name": "useWorkspaceTodoEditAddImageMutation",
    "operationKind": "mutation",
    "text": "mutation useWorkspaceTodoEditAddImageMutation(\n  $todoId: ID!\n) {\n  todoWorkspace(id: $todoId) {\n    uploadImage {\n      image {\n        id\n      }\n      imageUploadUrl\n      todoWorkspace {\n        id\n        ...WorkspaceTodoEditMainEditedInfo_Todo\n        descriptionImages {\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment FormattedDate on Date {\n  __isDate: __typename\n  ...useFormattedDate\n}\n\nfragment WorkspaceTodoEditMainEditedInfo_Todo on TodoWorkspace {\n  updatedBy {\n    id\n    name\n  }\n  updatedAtDate {\n    ...FormattedDate\n  }\n}\n\nfragment useFormattedDate on Date {\n  __isDate: __typename\n  isoString\n}\n"
  }
};
})();

(node as any).hash = "3d233b18c9f9c0f42eaf27001ec76ea4";

export default node;
